module.exports = __webpack_public_path__ + "media/images/common/ico-bell-off-d1f5bdb59bcd6d091c4112d2bf15eff6.svg";